import LoadingSideBar from './LoadingSideBar';
import LoadingTable from './LoadingTable';
import LoadingRectangle from './LoadingRectangle';
export { LoadingSideBar, LoadingTable, LoadingRectangle };
